import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { Modal } from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';

export const AccountErrorModal = ({ isModalOpen, closeModal }, { intl }) => {
  const i18n = id => intl.formatMessage({ id });
  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="">
      <ConfirmationDialog
        title={i18n('account_error_modal.title')}
        labelConfirm={i18n('notifications.close')}
        onConfirm={closeModal}
      >
        {i18n('account_error_modal.text')}
      </ConfirmationDialog>
    </Modal>
  );
};

AccountErrorModal.propTypes = {
  isModalOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

AccountErrorModal.contextTypes = {
  intl: PropTypes.object
};

export default pure(AccountErrorModal);
